import { s3, bucketName } from "@/plugins/bucket.js";

export const bucketApi = {
  async uploadImageToBucket(file) {
    const params = {
      ACL: "public-read",
      Bucket: bucketName,
      Key: `instructions/${Date.now()}${file.name}`,
      Body: file
    };
    const options = { partSize: 10 * 1024 * 1024, queueSize: 1 };
    const res = await s3.upload(params, options).promise();
    return {
      success: 1,
      file: {
        url: res.Location
      }
    };
  }
};
